import { style } from 'typestyle'
export const pt20 = style({ paddingTop: '20px' })
